import { render, staticRenderFns } from "./BRadioCard.vue?vue&type=template&id=5760823b&scoped=true"
import script from "./BRadioCard.vue?vue&type=script&lang=ts"
export * from "./BRadioCard.vue?vue&type=script&lang=ts"
import style0 from "./BRadioCard.vue?vue&type=style&index=0&id=5760823b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5760823b",
  null
  
)

export default component.exports